import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'mobx-react';
import LocaleProvider, {
  enUS,
} from '@elevio/elevio-styles/dist/components/hq/localeProvider';
import { PROJECT_NAME } from './config';
import Basket from './components/basket/basket';
import FormStore from './stores/form';

export default class App extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  static childContextTypes = {
    domContainer: PropTypes.func.isRequired,
  };

  getChildContext() {
    return {
      domContainer: () =>
        this.ref || document.getElementsByClassName(PROJECT_NAME)[0],
    };
  }

  render() {
    return (
      <div
        id="container"
        ref={r => {
          this.ref = r;
        }}
        className={PROJECT_NAME}
      >
        <LocaleProvider locale={enUS}>
          <Provider
            settingsStore={FormStore.settingsStore}
            formStore={FormStore}
          >
            <Basket>{this.props.children}</Basket>
          </Provider>
        </LocaleProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js